module.exports = __webpack_public_path__ + "img/certificate-3.08ba0749.png";